// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"mi-oFI1U","label":"_8HpZ8BUZ","dollarSign":"_1S4Ucdi4","input":"_16gAQGJK"};